import DownloadIcon from "@mui/icons-material/GetApp";
import { CircularProgress, IconButton } from "@mui/material";
import useNotify from "./useNotify";
import React from "react";

const DownloadFieldLink = ({ ...props }) => {
  const { filelink, filename, sx } = props;
  const [loading, setLoading] = React.useState(false);
  const [progress, setProgress] = React.useState<number | null>(null);

  // const reqUrl = `${import.meta.env.VITE_API_URL}/${filelink}`;
  const reqUrl = `${import.meta.env.VITE_API_URL}/${filelink.replace(
    /^\//,
    ""
  )}`;

  const { error, info } = useNotify();

  const handDownload = async (docFileName: string, reqUrl: string) => {
    setLoading(true);
    setProgress(null);
    try {
      const access_token = localStorage.getItem("access_token");
      const csrfToken = localStorage.getItem("csrfToken");

      const response = await fetch(`${reqUrl}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "X-CSRF-TOKEN": csrfToken ?? "",
          "X-XSRF-TOKEN": csrfToken ?? "",
          "Content-Type": "application/json",
        },
      });

      // console.log("Response:", response);

      if (!response.ok) {
        // 尝试解析错误信息（可能是 JSON）
        try {
          const errorData = await response.json();
          error(errorData.message || "Request failed");
        } catch {
          error("Network response was not ok");
        }
        return;
      }

      const contentType = response.headers.get("content-type");

      // 接口返回 JSON/HTML 时通常是错误信息，不进入文件下载流程
      if (
        contentType?.includes("application/json") ||
        contentType?.includes("text/html")
      ) {
        const textData = await response.text();
        try {
          const jsonData = JSON.parse(textData);
          if (jsonData.message) {
            error(jsonData.message);
            return;
          }
        } catch {
          error("Download failed");
          return;
        }
      }
      //if contentType is zip , download as zip
      if (contentType?.includes("application/zip")) {
        docFileName = docFileName.endsWith(".zip")
          ? docFileName
          : `${docFileName}.zip`;
      }

      // 按流下载，loading 与真实传输过程一致
      const contentLength = Number(response.headers.get("content-length") || 0);
      const reader = response.body?.getReader();
      if (!reader) {
        error("Download stream is unavailable");
        return;
      }

      const chunks: ArrayBuffer[] = [];
      let receivedLength = 0;

      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          break;
        }
        if (value) {
          const normalizedChunk = new Uint8Array(value.byteLength);
          normalizedChunk.set(value);
          chunks.push(normalizedChunk.buffer);
          receivedLength += normalizedChunk.length;
          if (contentLength > 0) {
            const nextProgress = Math.min(
              100,
              Math.round((receivedLength / contentLength) * 100)
            );
            setProgress(nextProgress);
          }
        }
      }

      const blob = new Blob(chunks, {
        type: contentType || "application/octet-stream",
      });
      if (blob.size === 0) {
        error("File is empty");
        return;
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = docFileName;
      document.body.appendChild(link);
      link.click();

      //clear
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
      // info(
      //   "File download has started. Saving may take a moment in your browser."
      // );
    } catch (err) {
      error("Failed to download file");
    } finally {
      setLoading(false);
      setProgress(null);
    }
  };

  return (
    <IconButton
      onClick={() => handDownload(filename, reqUrl)}
      sx={sx}
      disabled={loading}
    >
      {loading ? (
        <CircularProgress
          size={24}
          variant={
            typeof progress === "number" ? "determinate" : "indeterminate"
          }
          value={typeof progress === "number" ? progress : undefined}
        />
      ) : (
        <DownloadIcon sx={{ color: "#1976d2" }} />
      )}
    </IconButton>
  );
};

export default DownloadFieldLink;
